import { ShapeEditor } from 'app/agriculture/forms/components/ShapeEditor/ShapeEditor';
import { getGeometryType } from 'app/agriculture/routes/Infra/getGeometryType';
import { Controller, useFormContext } from 'react-hook-form';
import { InfraType } from 'app/agriculture/mutations/types/entityConfig';
import { isBillboardEntityType } from 'app/agriculture/models/Entities';
import { MapEntity } from '../../../queries/types/geometry/MapEntity';
import { geometryEmpty, minPoints, selfIntersections, tooLarge, tooLong } from './utils';

interface ShapeEditorMapInputProps {
    infraType: InfraType;
}
export function ShapeEditorMapInput({ infraType }: ShapeEditorMapInputProps) {
    const form = useFormContext<{ geometry?: MapEntity['geometry'] }>();
    if (isBillboardEntityType(infraType)) return null;

    return (
        <Controller
            control={form.control}
            name="geometry"
            rules={{
                required: 'Please select a location on the map.',
                validate: {
                    isEmptyGeometry: geometryEmpty,
                    hasTooFewPoints: (geometry?: MapEntity['geometry']) =>
                        minPoints(infraType, geometry),
                    isSelfIntersecting: (geometry?: MapEntity['geometry']) =>
                        selfIntersections(infraType, geometry),
                    isTooLong: (geometry?: MapEntity['geometry']) => tooLong(infraType, geometry),
                    isTooLarge: (geometry?: MapEntity['geometry']) => tooLarge(infraType, geometry),
                },
            }}
            render={({ field }) => {
                return (
                    <ShapeEditor
                        geometry={
                            field.value ?? {
                                type: getGeometryType(infraType),
                                coordinates: [],
                            }
                        }
                        onChange={field.onChange}
                        infraType={infraType}
                    />
                );
            }}
        />
    );
}
